import React from 'react';
import { Box } from '@leagueplatform/genesis-core';
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import { MasonryChart } from '#types/masonry-chart.type.ts';
import { Chart } from './chart.component';

type ChartRendererNode = MasonryEngineNode<
  'chart',
  MasonryChart & {
    items: React.ReactElement[];
  }
>;
export type ChartRendererProps =
  MasonryEngineNodeRendererProps<ChartRendererNode>;

export function ChartRenderer({
  chartType,
  interval,
  aggregationBucketType,
  screenReaderTitle,
  screenReaderDescription,
  yAxisLabel,
  yAxisMax,
  xAxisLabel,
  dataset,
  dataPointTypes,
  items,
}: ChartRendererProps) {
  return (
    <>
      {/* Container for injecting elements alongside the main chart (e.g., overview panel). */}
      {items}
      <Box css={{ height: 500, width: '100%', marginBottom: '$twoAndHalf' }}>
        <Chart
          chartType={chartType}
          interval={interval}
          aggregationBucketType={aggregationBucketType}
          screenReaderTitle={screenReaderTitle}
          screenReaderDescription={screenReaderDescription}
          yAxisLabel={yAxisLabel}
          yAxisMax={yAxisMax}
          xAxisLabel={xAxisLabel}
          dataset={dataset}
          dataPointTypes={dataPointTypes}
        />
      </Box>
    </>
  );
}
